module.exports = __webpack_public_path__ + "img/fqqy.04b51015.jpg";